<template>
  <div style="
        background-color: #fff;
        border: 1px solid #e0e0e0;
        border-top: 0px;
        border-radius: 0 0 3px 3px;
      ">
    <div id="tabPerformance" class="margin-subpages">
      <div class="flex-row-between mt-24">
        <div style="width: 320px">
          <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style"
            :class="[blurMode ? 'blurelement' : '']" @change="changMainPageData">
            <el-option class="text-dropdown" :class="[blurMode ? 'blurelement' : '']" v-for="item in teamAndcohort"
              :key="item.key" :label="item.name" :value="item.key"></el-option>
          </el-select>
        </div>
        <div>
          <el-button type="primary"
            style="background: #F0F0F0; color: #000000; border: none; font-size: 14px; padding: 12px 16px;"
            @click="OnClickModalPresets">
            <div style="display: flex; align-items: center; gap: 8px;">
              <img :src="$utils('icons', 'setting_Icon')" style="width: 16px; height: 16px;">
              <span>Performance Presets</span>
            </div>
          </el-button>
        </div>
      </div>
      <div class="mt-32 grid-2-50" style="align-items: center;">
        <div>
          <!-- line chart -->
          <div class="performance-container pl-24">
            <div class="fs-16 fw-600"> Performance Tracker</div>
            <div class="flex-row mt-12" style="align-items: center;">

              <div class="legend-box box-complete" style="background-color: #5682A3;"></div>
              <span class="ml-4 mr-12 fs-11">Culture Add ({{ loading || avg.cultuerAdd === undefined ? '-' :
                avg.cultuerAdd }}%)</span>

              <div class="legend-box box-pending" style="background-color: #7D5ABA;"></div>
              <span class="ml-4 mr-12 ml-4 fs-11"> Goals Progress ({{ loading || avg.GoalsProgress === undefined ? '-' :
                avg.GoalsProgress }}%)</span>

              <div class="legend-box box-overdue" style="background-color: #FF6F91;"></div>
              <span class="ml-4 fs-11">Both ({{ loading || avg.Both === undefined ? '-' : avg.Both }}%)</span>

            </div>
            <div class="mt-16 pb-12" style="width: 384px">
              <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading">
                <loading-even></loading-even>
              </div>
              <div>

                <canvas height="247px" width="384px" ref="PerformanceChart"></canvas>

                <div class="timeline ml-30">
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                </div>
                <div class="labels fs-14 fw-600 fc-777777 ml-30 pt-8">
                  <div class="start">{{ month }}</div>
                  <div class="start">Today</div>
                </div>
              </div>
            </div>
          </div>
          <div class="performance-container pl-24 mt-16 pb-24">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div class="fs-16 fw-700"> Boosts Status</div>
            </div>
            <div class="flex-row mt-12" style="align-items: center;">

              <div class="legend-box box-complete"></div>
              <span class="ml-4 mr-12 fs-11">Completed ({{ loading || getReviewsStatus(reviewActivity.completed) ===
                undefined ? '-' : getReviewsStatus(reviewActivity.completed) }}%)</span>

              <div class="legend-box box-pending"></div>
              <span class="ml-4 mr-12 ml-4 fs-11"> Pending ({{ loading || getReviewsStatus(reviewActivity.pending) ===
                undefined ? '-' : getReviewsStatus(reviewActivity.pending) }}%)</span>

              <div class="legend-box box-overdue"></div>
              <span class="ml-4 fs-11">Overdue ({{ loading || getReviewsStatus(reviewActivity.overdue) === undefined ?
                '-' : getReviewsStatus(reviewActivity.overdue) }}%)</span>

            </div>
            <div class="flex-row mt-12 pb-24" style="align-items: center; width: 404px;">

              <div class="progress-bar box-complete" :style="`width:${getReviewsStatus(reviewActivity.completed)}%`">
              </div>


              <div class="progress-bar box-pending" :style="`width:${getReviewsStatus(reviewActivity.pending)}%`"></div>


              <div class="progress-bar box-overdue" :style="`width:${getReviewsStatus(reviewActivity.overdue)}%`"></div>


            </div>

          </div>

        </div>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading">
          <loading-even></loading-even>
        </div>
        <div v-else class="flex-row ml-36">
          <div>
            <div class="fs-16 fw-700 rotate-goal"><span
                style="position: absolute;height: 335px;text-align: center;">Culture Add</span></div>
          </div>
          <div>
            <div class="flex-row">
              <div class="flex-row" style="width: 102px;">
                <div class="fs-12 rotate fc-FF6F91 mr-8"><span
                    style="position: absolute;height: 77px;text-align: center;">Significantly</span></div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 1 }"
                  @click="filterGridData(4, 1)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[4][1], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[4][1], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[4][1] == 0 ? '' : ChartGoalandCuture[4][1] }}</div>
                  </div>
                </div>
              </div>

              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 2 }"
                @click="filterGridData(4, 2)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[4][2], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[4][2], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[4][2] == 0 ? '' : ChartGoalandCuture[4][2] }}</div>
                </div>
              </div>
              <div class="box-performace-pink mr-10"
                :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 3 }"
                @click="filterGridData(4, 3)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 3 ? '#ffd1e5' : '#FF6F9120',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[4][3], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[4][3], ChartGoalandCuture.mex) + 'px',
                  color: '#FF6F91',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[4][3] == 0 ? '' : ChartGoalandCuture[4][3] }}</div>
                </div>
              </div>
              <div class="box-performace-pink mr-10"
                :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 4 }"
                @click="filterGridData(4, 4)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 4 ? '#ffd1e5' : '#FF6F9120',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[4][4], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[4][4], ChartGoalandCuture.mex) + 'px',
                  color: '#FF6F91',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[4][4] == 0 ? '' : ChartGoalandCuture[4][4] }}</div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-9">
              <div class="flex-row" style="width: 102px;">
                <div class="fs-12 rotate fc-FF6F91 mr-8"><span
                    style="position: absolute;height: 77px;text-align: center;">Consistently</span></div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 1 }"
                  @click="filterGridData(3, 1)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[3][1], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[3][1], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[3][1] == 0 ? '' : ChartGoalandCuture[3][1] }}</div>
                  </div>
                </div>
              </div>


              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 2 }"
                @click="filterGridData(3, 2)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[3][2], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[3][2], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[3][2] == 0 ? '' : ChartGoalandCuture[3][2] }}</div>
                </div>
              </div>
              <div class="box-performace-pink mr-10"
                :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 3 }"
                @click="filterGridData(3, 3)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 3 ? '#ffd1e5' : '#FF6F9120',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[3][3], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[3][3], ChartGoalandCuture.mex) + 'px',
                  color: '#FF6F91',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[3][3] == 0 ? '' : ChartGoalandCuture[3][3] }}</div>
                </div>
              </div>
              <div class="box-performace-pink mr-10"
                :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 4 }"
                @click="filterGridData(3, 4)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 4 ? '#ffd1e5' : '#FF6F9120',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[3][4], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[3][4], ChartGoalandCuture.mex) + 'px',
                  color: '#FF6F91',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[3][4] == 0 ? '' : ChartGoalandCuture[3][4] }}</div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-9">
              <div class="flex-row" style="width: 102px;">
                <div class="fs-12 rotate mr-8"><span
                    style="position: absolute;height: 77px;text-align: center;">Somewhat</span></div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 1 }"
                  @click="filterGridData(2, 1)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[2][1], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[2][1], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[2][1] == 0 ? '' : ChartGoalandCuture[2][1] }}</div>
                  </div>
                </div>
              </div>


              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 2 }"
                @click="filterGridData(2, 2)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[2][2], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[2][2], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[2][2] == 0 ? '' : ChartGoalandCuture[2][2] }}</div>
                </div>
              </div>
              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 3 }"
                @click="filterGridData(2, 3)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 3 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[2][3], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[2][3], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[2][3] == 0 ? '' : ChartGoalandCuture[2][3] }}</div>
                </div>
              </div>
              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 4 }"
                @click="filterGridData(2, 4)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 4 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[2][4], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[2][4], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[2][4] == 0 ? '' : ChartGoalandCuture[2][4] }}</div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-9">
              <div class="flex-row" style="width: 102px;">
                <div class="fs-12 rotate mr-8"><span
                    style="position: absolute;height: 77px;text-align: center;">Rarely</span></div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 1 }"
                  @click="filterGridData(1, 1)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[1][1], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[1][1], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[1][1] == 0 ? '' : ChartGoalandCuture[1][1] }}</div>
                  </div>
                </div>
              </div>

              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 2 }"
                @click="filterGridData(1, 2)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[1][2], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[1][2], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[1][2] == 0 ? '' : ChartGoalandCuture[1][2] }}</div>
                </div>
              </div>
              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 3 }"
                @click="filterGridData(1, 3)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 3 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[1][3], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[1][3], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[1][3] == 0 ? '' : ChartGoalandCuture[1][3] }}</div>
                </div>
              </div>
              <div class="box-performace mr-10"
                :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 4 }"
                @click="filterGridData(1, 4)">
                <div class="fs-14 flex-mid" :style="{
                  backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 4 ? '#d1d1ff' : '#eaeaea',
                  borderRadius: '50%',
                  width: calculateDimension(ChartGoalandCuture[1][4], ChartGoalandCuture.mex) + 'px',
                  height: calculateDimension(ChartGoalandCuture[1][4], ChartGoalandCuture.mex) + 'px',
                  color: '#4D4D4D',
                  cursor: 'pointer'
                }">
                  <div class="count">{{ ChartGoalandCuture[1][4] == 0 ? '' : ChartGoalandCuture[1][4] }}</div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-9">
              <div style="width: 15px;"></div>
              <div class="fs-12 mr-10" style="width: 77px ;text-align: center;">Did Not Meet</div>
              <div class="fs-12 mr-10" style="width: 77px ;text-align: center;">Partially</div>
              <div class="fc-FF6F91 fs-12 mr-10" style="width: 77px ;text-align: center;">Met</div>
              <div class="fs-12 mr-10 fc-FF6F91" style="width: 77px ;text-align: center;">Exceeded</div>
            </div>
            <div class="fs-16 fw-700 mt-16" style="text-align: center;">
              Goal Progress
            </div>
          </div>

        </div>
      </div>

      <div>
        <div class="flex-row-between mt-24">
          
          <!-- Filter Component -->
          <div v-if="isFiltered" class="debug-info mt-16 mb-16">
            <div class="flex-row-between">
              <!-- Selection Labels -->
              <div class="flex-row align-center">
                <div>
                  <div class="fs-15 fw-700 mb-8">Active Filter</div>
                  <div class="fs-13 fc-666666">
                    <template v-if="activeFilter.culture !== null && activeFilter.goal !== null">
                      <span class="mr-12"><strong>Culture:</strong> {{ getCultureText(activeFilter.culture) }}</span>
                      <span><strong>Goal:</strong> {{ getGoalText(activeFilter.goal) }}</span>
                    </template>
                  </div>
                </div>
              </div>

              <div class="flex-row align-center">
                <!-- Status Checkboxes -->
                <div class="status-filters flex-row" style="gap: 12px; margin-right: 24px;">
                  <div class="status-filter-checkbox">
                    <el-checkbox v-model="statusFilters.completed" @change="updateStatusFilters" class="purple-checkbox">
                      <div class="flex-row align-center fc-000000" style="line-height: 0.6">
                        <div class="legend-box box-complete mr-4"></div>
                        <span style="vertical-align: middle">Completed 
                          <span class="status-count">
                            <template v-if="isFiltered && statusCounts.filtered.completed !== statusCounts.total.completed">
                              ({{ statusCounts.filtered.completed }})
                            </template>
                            <template v-else>
                              ({{ statusCounts.total.completed }})
                            </template>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>

                  <div class="status-filter-checkbox">
                    <el-checkbox v-model="statusFilters.pending" @change="updateStatusFilters">
                      <div class="flex-row align-center fc-000000" style="line-height: 0.6">
                        <div class="legend-box box-pending mr-4"></div>
                        <span style="vertical-align: middle">Pending 
                          <span class="status-count">
                            <template v-if="isFiltered && statusCounts.filtered.pending !== statusCounts.total.pending">
                              ({{ statusCounts.filtered.pending }})
                            </template>
                            <template v-else>
                              ({{ statusCounts.total.pending }})
                            </template>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>

                  <div class="status-filter-checkbox">
                    <el-checkbox v-model="statusFilters.overdue" @change="updateStatusFilters">
                      <div class="flex-row align-center fc-000000" style="line-height: 0.6">
                        <div class="legend-box box-overdue mr-4"></div>
                        <span style="vertical-align: middle">Overdue 
                          <span class="status-count">
                            <template v-if="isFiltered && statusCounts.filtered.overdue !== statusCounts.total.overdue">
                              ({{ statusCounts.filtered.overdue }})
                            </template>
                            <template v-else>
                              ({{ statusCounts.total.overdue }})
                            </template>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>
                </div>

                <!-- Clear Filter Button -->
                <el-button size="mini" type="primary" class="clear-filter-btn" @click="clearFilter">Clear Filter</el-button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="flex-row-between mt-24 mb-24">
        <div class="flex-row align-center">
          <el-input class="input-style ml-24" style="font-size: 15px; width: 260px !important" autosize
            :placeholder="$t('global.Search')" @keyup.native="searchData" v-model="inputSearch" clearable></el-input>
        </div>

        <div class="flex-row align-center">
          <div style="width: 240px">
            <div class="flex-row">
              <div>
                <el-menu id="menuSortPerformanceData" class="el-menu-demo menuOptionPowerup" mode="horizontal">
                  <el-submenu index="1" style>
                    <template slot="title">
                      <span class="txtOptionShowing">{{ list_select }}</span>
                    </template>
                    <el-menu-item v-bind:key="item.id" v-for="item in list" index="1" @click="selectOption(item)"><span
                        class="menu-list-item">{{ item }}</span></el-menu-item>
                  </el-submenu>
                </el-menu>
              </div>
            </div>
          </div>
          <el-button type="primary" style="margin-left: 16px; background: #F0F0F0; color: #000000; border: none; font-size: 14px; padding: 12px 16px;" @click="exportdata(tableData)">
            <div style="display: flex; align-items: center; gap: 8px;">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L8 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M4 8L8 4L12 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 13H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>Export</span>
            </div>
          </el-button>
        </div>
      </div>

      <!-- Empty state when no data matches filters -->
      <div v-if="isFiltered && filteredTableData.length === 0" class="empty-state-container">
        <div class="empty-state-icon">
          <i class="el-icon-search"></i>
        </div>
        <h3 class="empty-state-title">No matching results found</h3>
        <p class="empty-state-message">
          We couldn't find any data that matches your current filter selections.
        </p>
        <div class="empty-state-suggestions">
          <p>Try one of these:</p>
          <ul>
            <li>Adjust your status filters (Completed, Pending, Overdue)</li>
            <li>Modify your culture or goal selections</li>
            <li>Clear all filters and start again</li>
          </ul>
        </div>
        <el-button type="primary" class="empty-state-action" @click="clearFilter">
          Clear All Filters
        </el-button>
      </div>
     
      <!-- Table data (only show when there is data) -->
      <div v-else class="divTable">
        <el-table :data="filteredTableData" style="width: 100%" :empty-text="$utils('placeholderInTable', {
          loadingLoop: loading,
        })" :expand-row-keys="expandedRows" row-key="email">
          <el-table-column type="expand">
            <template #default="props">
              <div class="nestedTable">
                <el-table :data="props.row.family" class="nested-table">
                  <el-table-column label="Team Member">
                    <template slot-scope="scope">
                      <div class="flex-center" style="height: 40px">
                        <div style="width: 32px" class="mr-12">
                          <div class="flex-center" v-if="scope.row.profilepic_crop">
                            <img v-lazy="scope.row.profilepic_crop" :key="scope.row.profilepic_crop"
                              class="image-skeleton image-profile-32" :class="[blurMode ? 'blurelement' : '']" />
                          </div>
                          <div v-else-if="scope.row.profilepic">
                            <img v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                              class="image-skeleton image-profile-32" :class="[blurMode ? 'blurelement' : '']" />
                          </div>
                          <div v-else class="image image-profile-32" :class="[blurMode ? 'blurelement' : '']">
                            <div class="text-in-image text-in-image-30 flex-mid">
                              {{
                                $utils("acronymName", {
                                  firstName: scope.row.firstname,
                                  lastName: scope.row.lastname,
                                })
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="flex-column" style="line-height: 20px">
                          <div style="width: 210px;">
                            <a v-if="scope.row.link" :href="scope.row.link" target="_blank" class="name-link">
                              <div class="fs-14 fw-700 fc-000000 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                                style="line-height: 16px;"
                                :title="[!blurMode ? `${scope.row.firstname} ${scope.row.lastname}` : '']">
                                {{ scope.row.firstname }} {{ scope.row.lastname }}
                                <svg class="hover-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M130.56-826l2.24-2.24v1.84h.8v-3.2h-3.2v.8h1.84L130-826.56Zm-8.96.4a1.541,1.541,0,0,1-1.13-.47,1.541,1.541,0,0,1-.47-1.13v-11.2a1.54,1.54,0,0,1,.47-1.13,1.54,1.54,0,0,1,1.13-.47h11.2a1.54,1.54,0,0,1,1.13.47,1.54,1.54,0,0,1,.47,1.13v5.36a6.558,6.558,0,0,0-.78-.31,4.89,4.89,0,0,0-.82-.19v-4.86H121.6v11.2h4.84a4.819,4.819,0,0,0,.19.84,5.5,5.5,0,0,0,.31.76Zm0-2.4v0Zm1.6-.8h3.26a4.882,4.882,0,0,1,.19-.82q.13-.4.29-.78H123.2Zm0-3.2h4.88a6.123,6.123,0,0,1,1.43-1,5.631,5.631,0,0,1,1.69-.54v-.06h-8Zm0-3.2h8v-1.6h-8ZM132-824a3.855,3.855,0,0,1-2.83-1.17A3.855,3.855,0,0,1,128-828a3.855,3.855,0,0,1,1.17-2.83A3.855,3.855,0,0,1,132-832a3.855,3.855,0,0,1,2.83,1.17A3.855,3.855,0,0,1,136-828a3.855,3.855,0,0,1-1.17,2.83A3.855,3.855,0,0,1,132-824Z"
                                    transform="translate(-120 840)" opacity="0.995" />
                                </svg>
                              </div>
                            </a>
                            <a v-else href="#" class="name-link"
                              @click.prevent="$message.warning('There is no Performance Summary available yet. Awaiting first Performance Boost from the direct manager.')">
                              <div class="fs-14 fw-700 fc-000000 ellipsis" style="line-height: 16px;"
                                :title="[!blurMode ? `${scope.row.firstname} ${scope.row.lastname}` : '']">
                                {{ scope.row.firstname }} {{ scope.row.lastname }}
                                <svg class="hover-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M130.56-826l2.24-2.24v1.84h.8v-3.2h-3.2v.8h1.84L130-826.56Zm-8.96.4a1.541,1.541,0,0,1-1.13-.47,1.541,1.541,0,0,1-.47-1.13v-11.2a1.54,1.54,0,0,1,.47-1.13,1.54,1.54,0,0,1,1.13-.47h11.2a1.54,1.54,0,0,1,1.13.47,1.54,1.54,0,0,1,.47,1.13v5.36a6.558,6.558,0,0,0-.78-.31,4.89,4.89,0,0,0-.82-.19v-4.86H121.6v11.2h4.84a4.819,4.819,0,0,0,.19.84,5.5,5.5,0,0,0,.31.76Zm0-2.4v0Zm1.6-.8h3.26a4.882,4.882,0,0,1,.19-.82q.13-.4.29-.78H123.2Zm0-3.2h4.88a6.123,6.123,0,0,1,1.43-1,5.631,5.631,0,0,1,1.69-.54v-.06h-8Zm0-3.2h8v-1.6h-8ZM132-824a3.855,3.855,0,0,1-2.83-1.17A3.855,3.855,0,0,1,128-828a3.855,3.855,0,0,1,1.17-2.83A3.855,3.855,0,0,1,132-832a3.855,3.855,0,0,1,2.83,1.17A3.855,3.855,0,0,1,136-828a3.855,3.855,0,0,1-1.17,2.83A3.855,3.855,0,0,1,132-824Z"
                                    transform="translate(-120 840)" opacity="0.995" />
                                </svg>
                              </div>
                            </a>
                            <div class="fc-000000 opa-06 fs-13 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                              style="line-height: 20px;">
                              {{ scope.row.team_name }}
                            </div>
                          </div>

                        </div>


                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-13" style="line-height: 14px;">Status</div>
                      <div class="fs-12 fc-000000 opa-05" style="line-height: 16px;">Current period</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid"
                        :style="`background:${getStatusColor(scope.row.reviews_status)};border-radius: 8px; color:${getStatusColortext(scope.row.reviews_status)};`">
                        {{ scope.row.reviews_status }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-13" style="line-height: 14px;">Goal Progress</div>
                      <div class="fs-12 fc-000000 opa-05" style="line-height: 16px;">vs Target</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid"
                        :style="`background:${getgoalsColor(scope.row.goalText)};border-radius: 8px; color:${getgoalsColortext(scope.row.goalText)};`">
                        {{ scope.row.goalText }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="address" width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-13" style="line-height: 14px;">Culture Add</div>
                      <div class="fs-12 fc-000000 opa-05" style="line-height: 16px;">Contribution level</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid"
                        :style="`background:${getcultureAddColor(scope.row.cultureText)};border-radius: 8px; color:${getcultureAddColortext(scope.row.cultureText)};`">
                        {{ scope.row.cultureText }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="zip" width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-13" style="line-height: 14px;">Track Record</div>
                      <div class="fs-12 fc-000000 opa-05" style="line-height: 16px;">← Most recent</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid">
                        <div v-for="(item, index) in scope.row.track.slice().reverse()" :key="index">
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content"><strong>{{ item.month }}</strong></div>
                            <div slot="content">{{ item.text }}</div>
                            <div slot="content"></br>{{ item.text1 }}</div>
                            <div slot="content" class="mt-8">
                              <span v-if="item.text1" class="delete-review-btn"
                                @click.stop="confirmDeleteReview(scope.row, item)">Delete</span>
                            </div>
                            <div class="flex-row align-center">
                              <img class="ml-4" style="width:18px;height: 18px;" v-lazy="item.track" :key="index" />
                            </div>
                          </el-tooltip>
                        </div>

                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Manager" width="245">
            <template slot-scope="scope">
              <div class="flex-center" style="height: 50px">
                <div style="width: 42px" class="mr-12">
                  <div class="flex-center" v-if="scope.row.profilepic_crop">
                    <img v-lazy="scope.row.profilepic_crop" :key="scope.row.profilepic_crop"
                      class="image-skeleton image-profile-42" :class="[blurMode ? 'blurelement' : '']" />
                  </div>
                  <div v-else-if="scope.row.profilepic">
                    <img v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                      class="image-skeleton image-profile-42" :class="[blurMode ? 'blurelement' : '']" />
                  </div>
                  <div v-else class="image image-profile-42" :class="[blurMode ? 'blurelement' : '']">
                    <div class="text-in-image text-in-image-40 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: scope.row.firstname,
                          lastName: scope.row.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div class="flex-column" style="line-height: 20px">
                  <div style="width: 165px">
                    <div class="fs-14 fw-700 fc-000000 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                      style="line-height: 16px;"
                      :title="[!blurMode ? `${scope.row.firstname} ${scope.row.lastname}` : '']">
                      {{ scope.row.firstname }} {{ scope.row.lastname }}
                    </div>
                    <div class="fc-000000 opa-06 fs-13 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                      style="line-height: 20px;">
                      {{ scope.row.team_name }}
                    </div>
                  </div>

                </div>


              </div>


            </template>
          </el-table-column>
          <el-table-column label="Boosts On Track" header-align="center">

            <template slot="header">
              <el-tooltip placement="top">
                <template #content>Performance reviews that are either completed or pending but not overdue</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Boosts On Track
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.reviewCompleted }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.reviewCompleted)" color="#66BB6A" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column header-align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <template #content><strong>Goal contribution weight</strong><br>• Exceeded Goals is 100%<br>• Met Goals
                  is 100%<br>• Partially Met is 50%<br>• Did Not Meet is 0%</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Goal Progress
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.GoalsProgress }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.GoalsProgress)" color="#7D5ABA" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>
              </div>
            </template>



          </el-table-column>
          <el-table-column label="Culture Add" header-align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <template #content><strong>Culture contribution weight</strong><br>• Significantly is 100%<br>•
                  Consistently is 100%<br>• Somewhat is 50%<br>• Rarely is 0%</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Culture Add
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.cultuerAdd }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.cultuerAdd)" color="#5682A3" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>

              </div>
            </template>



          </el-table-column>

          <el-table-column label="Both" header-align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <template #content>A combination of both goal progress and culture add</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Both
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.both }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.both)" color="#FF6F91" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>

              </div>
            </template>



          </el-table-column>
        </el-table>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading">
          <loading-even></loading-even>
        </div>
      </div>




      <!-- Modal Performance Presets -->
      <el-dialog :visible.sync="showModal_presets" :before-close="closeModalPresets" width="1100px" top="8vh">
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:640px; ">

            <div class="flex-column" style="margin-top: 40px;">
              <div class="flex-center" style="justify-content: space-between;">
                <div class="flex-column">
                  <span class="fs-20 fw-700 mb-8" style="color: #000;">
                    Performance Presets
                  </span>
                  <div class="opa-06">
                    Manage performance boost templates and assignments
                  </div>

                </div>

                <el-button
                  style="width:133.7px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;margin-right: 32px;padding: 0px;"
                  @click="createPreset">
                  <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                    <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor">
                      <path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z" />
                    </svg>
                    <span>Create Preset</span>
                  </div>
                </el-button>

              </div>
              <div class="fs-16 fw-700 pt-32 fc-323232" style="margin-top: 20px;">My Presets Library</div>
              <div>
                <el-input class="input-style mb-32 mt-12 " style="font-size: 15px; width: 260px !important" autosize
                  :placeholder="$t('global.Search')" v-model="inputSearch_preset" clearable></el-input>
              </div>



              <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading_preset">
                <loading-even></loading-even>
              </div>
              <div v-else-if="!presetlist || presetlist.length === 0"
                class="empty-state-container mt-20 mb-40 pt-40 pb-40">
                <div class="flex-column" style="align-items: center; text-align: center;">
                  <svg width="80" height="80" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#C8C8C8"
                    style="margin-bottom: 16px;">
                    <rect x="3" y="4" width="18" height="4" rx="1" opacity="0.6" />
                    <circle cx="5.5" cy="6" r="1.5" />
                    <rect x="8" y="5" width="10" r="1" height="1" rx="0.5" />
                    <rect x="8" y="7" width="6" height="0.5" rx="0.25" opacity="0.7" />

                    <rect x="3" y="10" width="18" height="4" rx="1" opacity="0.6" />
                    <circle cx="5.5" cy="12" r="1.5" />
                    <rect x="8" y="11" width="10" height="1" rx="0.5" />
                    <rect x="8" y="13" width="6" height="0.5" rx="0.25" opacity="0.7" />

                    <rect x="3" y="16" width="18" height="4" rx="1" opacity="0.6" />
                    <circle cx="5.5" cy="18" r="1.5" />
                    <rect x="8" y="17" width="10" height="1" rx="0.5" />
                    <rect x="8" y="19" width="6" height="0.5" rx="0.25" opacity="0.7" />
                  </svg>
                  <span class="fs-16 fw-700 mb-8" style="color: #323232;">No presets found</span>
                  <p class="fs-14 opa-06 mb-16">Create your first performance preset to get started</p>
                  <el-button
                    style="width:133.7px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;"
                    @click="createPreset">
                    <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                      <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor">
                        <path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z" />
                      </svg>
                      <span>Create Preset</span>
                    </div>
                  </el-button>
                </div>
              </div>
              <div v-else>
                <!-- card -->
                <div v-for="(item, index) in presetlist" :key="index" class="mb-8 cursor-pointer"
                  :class="`${item.focus_preset ? 'preset-focus' : 'preset-library'}`" @click="ClickEditPresets(index)">
                  <div class="flex-center" style="justify-content: left;">

                    <div class="flex-center" style="width: 396px;">
                      <div class="flex-center"
                        :style="`justify-content: center;background:${item.focus_preset ? '#EEE5FD' : '#EDEDED'} 0% 0% no-repeat padding-box;border-radius: 12px;width: 52px;height: 52px;color:${item.focus_preset ? '#6C30CC' : '#000'}`">
                        {{ item.total_assignments }}</div>
                      <div class="flex-column" style="margin-left: 16px;">
                        <span class="fs-15 fw-700 fc-2E2E2E">{{ item.name }}</span>
                        <span class="fs-13 fc-2E2E2E mt-4">{{ gettextAssigned((item.teams ? item.teams.length : 0),
                          (item.users ?item.users.length:0))}}</span>
                      </div>
                    </div>
                    <div class="flex-center" style="justify-content: space-between;width:205px;">

                      <div class="fs-12 fc-2E2E2E">{{ item.total_assignments }} assignments total</div>
                      <div class="arrow-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.477" height="20" viewBox="0 0 10.477 20">
                          <path id="Path_40066" data-name="Path 40066"
                            d="M102.335,54.335l-9.524,9.524a.476.476,0,1,1-.674-.674L101.324,54l-9.187-9.187a.476.476,0,0,1,.674-.674l9.524,9.524a.476.476,0,0,1,0,.674"
                            transform="translate(-91.998 -43.998)" />
                        </svg>
                      </div>

                    </div>


                  </div>



                </div>

              </div>





            </div>
          </div>

          <div class="modal-2" style="width:460px;">

            <div v-if="status_show_preset_forms" class="flex-center"
              style="justify-content: center;height: 100%;text-align: center;">
              <div class="fs-16 fw-700" style="color: #000;opacity: 0.4;">Create a Performance Preset to enable clear
                structured feedback between managers and their teams</div>
            </div>
            <div v-else>



              <div class="flex-column" style="margin-top: 40px;">
                <div class="fs-20 fw-700" style="color: #000;">{{ title_preset }}</div>
                <div class="fs-14 fw-700 pt-24">Preset Name</div>
                <div v-if="presetForm_verify.name == true" class="validate-worming-data">
                  <el-input class="input-style mt-8" style="font-size: 15px; width: 376px !important;" autosize
                    placeholder="Enter preset name" v-model="presetForm.name"></el-input>
                  <div class="validate-worming-data-text ">
                    Please enter a preset name
                  </div>
                </div>
                <div v-else>
                  <el-input class="input-style mt-8" style="font-size: 15px; width: 376px !important;" autosize
                    placeholder="Enter preset name" v-model="presetForm.name"></el-input>

                </div>



              </div>

              <div class="fs-14 fw-700 pt-16">Goals Feedback</div>
              <div v-if="presetForm_verify.goals == true" class="validate-worming-data">
                <el-input type="textarea" class="custom-textarea-preset mt-8"
                  style="font-size: 14px; width: 376px !important;height: 92px;" auto-complete="off"
                  placeholder="Enter goals feedback" v-model="presetForm.goals" clearable></el-input>
                <div class="validate-worming-data-text ">
                  Please enter a preset goals
                </div>
              </div>
              <div v-else>
                <el-input type="textarea" class="custom-textarea-preset mt-8"
                  style="font-size: 14px; width: 376px !important;height: 92px;" auto-complete="off"
                  placeholder="Enter goals feedback" v-model="presetForm.goals" clearable></el-input>

              </div>



              <div class="fs-14 fw-700 pt-16">Culture Feedback</div>

              <div v-if="presetForm_verify.culture == true" class="validate-worming-data">
                <el-input type="textarea" class="custom-textarea-preset mt-8"
                  style="font-size: 14px; width: 376px !important;height: 92px;" auto-complete="off"
                  placeholder="Enter culture feedback" v-model="presetForm.culture" clearable></el-input>
                <div class="validate-worming-data-text ">
                  Please enter a preset culture feedback
                </div>
              </div>
              <div v-else>
                <el-input type="textarea" class="custom-textarea-preset mt-8"
                  style="font-size: 14px; width: 376px !important;height: 92px;" auto-complete="off"
                  placeholder="Enter culture feedback" v-model="presetForm.culture" clearable></el-input>
              </div>

              <div class="fs-14 fw-700 pt-16">Next Review Date</div>

              <div v-if="presetForm_verify.next_review == true" class="validate-worming-data">
                <el-input type="textarea" class="custom-textarea-preset mt-8"
                  style="font-size: 14px; width: 376px !important;height: 92px;" auto-complete="off"
                  placeholder="Next Review Date" v-model="presetForm.next_review" clearable></el-input>
                <div class="validate-worming-data-text ">
                  Please enter a preset Next Review Date
                </div>
              </div>
              <div v-else>
                <el-input type="textarea" class="custom-textarea-preset mt-8"
                  style="font-size: 14px; width: 376px !important;height: 92px;" auto-complete="off"
                  placeholder="Next Review Date" v-model="presetForm.next_review" clearable></el-input>
              </div>
              <div class="flex-center mb-12" style="justify-content: space-between;">
                <div class="fs-16 fw-700 pt-16">Assign to Teams</div>
                <div class="fs-14 pt-16 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('team')"> + Add Teams
                </div>
              </div>
              <div v-for="team in presetForm.team" :key="team.id + 'team'" class="mb-8">
                <div class="flex-center"
                  style="justify-content: left;padding: 16px 6px 16px 12px;background: #F5EFFF 0% 0% no-repeat padding-box;">
                  <div class="flex-center" style="width: 376px;">
                    <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ team.name }}</div>
                    <div class="fs-13 pl-10 fc-908D95">{{ team.membersteams }} members</div>
                  </div>
                  <div class="pr-16 cursor-pointer" @click="deleteTeam(team.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                      <g id="Close" transform="translate(0.354 0.354)">
                        <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797"
                          stroke-miterlimit="10" stroke-width="1" />
                        <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)"
                          fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>


              <div class="flex-center mt-21 mb-12" style="justify-content: space-between;">
                <div class="fs-16 fw-700 pt-16">Assigned Members</div>
                <div class="fs-14 pt-16 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('member')"> + Add
                  Member
                </div>
              </div>
              <div v-for="users in presetForm.users" :key="users.email + 'members'" class="mb-8">
                <div class="flex-center"
                  style="justify-content: left;padding: 8px 6px 8px 12px;background: #F5EFFF 0% 0% no-repeat padding-box;">
                  <div class="flex-column" style="width: 376px;">
                    <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ users.firstname }} {{
                      users.lastname }}</div>
                    <div class="fs-13 pl-16 fw-400 fc-9D9D9D mt-2">{{ users.team_name }}</div>
                  </div>
                  <div class="pr-16 cursor-pointer" @click="deleteUser(users.email)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                      <g id="Close" transform="translate(0.354 0.354)">
                        <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797"
                          stroke-miterlimit="10" stroke-width="1" />
                        <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)"
                          fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>



              <div v-if="popup_preset.show" class="warning-popup-1">
                <div class="body flex-center" style="width: 368px;justify-content: space-between;">
                  <div class="fs-500 fc-FFFFFF fs-14">
                    {{ popup_preset.title }}
                  </div>
                  <div v-if="popup_preset.status == 'update'"><el-button
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color:#F44336;width:54px;height:32px;font:13px;"
                      @click="deletePreset">{{ popup_preset.button_left }}</el-button>
                    <el-button v-if="popup_preset.button_right"
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:92px;height:32px;font:13px"
                      @click="savePreset">{{ popup_preset.button_right }}</el-button>
                  </div>
                  <div v-else>
                    <el-button
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #6c30cc;width:62px;height:32px;font:13px;"
                      @click="clearData">{{ popup_preset.button_left }}</el-button>
                    <el-button
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:104px;height:32px;font:13px"
                      @click="savePreset">{{ popup_preset.button_right }}</el-button>
                  </div>



                </div>
              </div>



            </div>







          </div>


        </div>

      </el-dialog>

      <!-- Add Member and Team -->
      <el-dialog :visible.sync="addMemberTeam" :before-close="cancelselectedTeamandMember" width="1020px">
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:320px;background: #F8F8F8 0% 0% no-repeat padding-box !important;">
            <div class="fs-20 fc-2D2E36 fw-700 pt-44 pb-25">
              {{ addMemberTeamForm.type == 'team' ? selected_team.length : selected_user.length }} {{
                addMemberTeamForm.title_left }}
            </div>

            <div v-if="addMemberTeamForm.type == 'team'">
              <div v-for="team in selected_team" :key="`${team.id}_select_team`" class="fs-14 fc-4A4A4A fw-700 pb-16">
                <div class="flex-center" style="justify-content: space-between;">


                  <div class="flex-center" style="justify-content: left;">
                    <img
                      style="width: 42px;height: 42px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;">
                    <div>
                      <div class="fs-14 fc-4A4A4A fw-600">{{ team.name }}</div>
                      <div class="fs-14 fw-400 fc-9D9D9D">{{ team.membersteams }} members</div>
                    </div>
                  </div>


                  <div class="pr-32 cursor-pointer" @click="deleteTeam(team.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                      <g id="Close" transform="translate(0.354 0.354)">
                        <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797"
                          stroke-miterlimit="10" stroke-width="1" />
                        <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)"
                          fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                      </g>
                    </svg>
                  </div>

                </div>



              </div>
            </div>
            <div v-else>
              <div v-for="user in selected_user" :key="`${user.email}`" class="fs-14 fc-4A4A4A fw-700 pb-16">
                <div class="flex-center" style="justify-content: space-between;">


                  <div class="flex-center" style="justify-content: left;">
                    <img :src="user.profilepic_crop"
                      style="width: 42px;height: 42px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;">
                    <div>
                      <div class="fs-14 fc-4A4A4A fw-600">{{ user.firstname }} {{ user.lastname }}</div>
                      <div class="fs-14 fc-908D95 fw-400">{{ user.team_name }}</div>
                    </div>
                  </div>


                  <div class="pr-16 cursor-pointer" @click="deleteUser(user.email)">
                    <img :src="$utils('icons', 'x-16x16px')" style="width: 16px;height: 16px;">
                  </div>

                </div>



              </div>


            </div>
          </div>

          <div class="modal-2"
            style="width:700px;background: #FFFFFF 0% 0% no-repeat padding-box !important;overflow-y: hidden !important;overflow-x: hidden !important;">

            <div class="flex-column" style="justify-content: space-between;">
              <div class="fs-24 fw-700 pt-40" style="color: #2D2E36;">{{ addMemberTeamForm.title }}</div>
              <div>
                <el-input v-model="searchmemberandteamandMember" style="width: 300px;"
                  :placeholder="addMemberTeamForm.placeholder" class="w-100 pt-32"></el-input>
              </div>
              <div class="fs-14 fc-908D95 pt-24 pb-20">Results based on the search terms…</div>
              <div>

                <div v-if="addMemberTeamForm.type == 'team'">


                  <div class="flex-center"
                    style="justify-content: left; width: 700px;flex-wrap: wrap;margin-right: 40px;max-height: 550px;overflow-y: auto;">
                    <div v-for="(index, id) in addMemberTeamForm.team" :key="addMemberTeamForm.team[id].id"
                      :class="addMemberTeamForm.team[id].statusClick ? 'border-blue' : ''" class="selection-cell"
                      @click="selectedTeamAndMember(id, 'team')">
                      <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                        <div
                          style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;">
                        </div>
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <img
                            style="width: 40px;height: 40px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;margin-left: 16px;">
                          <div class="flex-column">
                            <div class="fs-14 fc-4A4A4A fw-700">{{ addMemberTeamForm.team[id].name }}</div>
                            <div class="fs-14 fc-9D9D9D">{{ addMemberTeamForm.team[id].users.length }} members</div>
                          </div>
                        </div>


                      </div>





                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex-center"
                    style="justify-content: left; width: 700px;flex-wrap: wrap;margin-right: 40px;max-height: 550px;overflow-y: auto;">
                    <div v-for="(index, id) in addMemberTeamForm.user" :key="addMemberTeamForm.user[id].email"
                      :class="addMemberTeamForm.user[id].statusClick ? 'border-blue' : ''" class="selection-cell"
                      @click="selectedTeamAndMember(id, 'user')">

                      <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                        <div
                          style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;">
                        </div>
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <img :src="addMemberTeamForm.user[id].profilepic_crop"
                            style="width: 40px;height: 40px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;margin-left: 16px;">
                          <div class="flex-column">
                            <div class="fs-14 fc-4A4A4A fw-700">{{ addMemberTeamForm.user[id].firstname }}
                              {{ addMemberTeamForm.user[id].lastname }}</div>
                            <div class="fs-14 fc-9D9D9D">{{ addMemberTeamForm.user[id].team_name }}</div>
                          </div>
                        </div>


                      </div>





                    </div>
                  </div>



                </div>




                <div class="flex-center" style="justify-content: right; margin-top: 20px;">
                  <el-button type="primary" style="width: 122px;height: 50px;background: #D1D1D1 0% 0% no-repeat padding-box;
                  border: none;" @click="cancelselectedTeamandMember">CANCEL</el-button>
                  <el-button type="primary" style="width: 120px;height: 50px;background: #32C2D5 0% 0% no-repeat padding-box;
                  border: none;" @click="submitselectedTeamandMember">SUBMIT</el-button>
                </div>

              </div>



            </div>




          </div>


        </div>

      </el-dialog>


      <!-- Submit member or team -->

      <el-dialog :visible.sync="confirm_add_dialog" width="650px" center style="max-height: 600px;min-height: 300px;"
        :before-close="handleClose">

        <div class="flex-column" style="height: 300px;max-height: 300px;">
          <div class="fs-16 fc-908D95 fw-700" style="margin-top: 50px;margin-left: 30px;">{{ `Some selected
            ${addMemberTeamForm.type == 'member' ? 'members' : 'teams'} have existing preset assignments` }}</div>

          <div v-for='(text, index) in text_confirm' :key="`${index}_text`"
            style="margin-top: 20px;margin-left: 30px;overflow-y: scroll;max-height: 300px;">
            {{ text }}
          </div>
          <div style="margin-top: 20px;margin-left: 30px;">Proceeding will override their existing preset assignments.
            Would
            you like to continue?</div>

        </div>
        <template>
          <div class="flex-center" style="justify-content: right;padding-bottom: 30px;padding-right: 30px;">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" @click="confirm_Add">
              Confirm
            </el-button>
          </div>
        </template>

      </el-dialog>

      <!-- Delete Review Confirmation Dialog -->
      <el-dialog :visible.sync="deleteReviewDialog.visible" width="560px" top="8vh" style="min-height: 300px;"
        :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
        <div class="center word-break" style="padding: 24px 24px; max-height: 60vh; overflow-y: auto;">
          <div class="fs-20 fw-700 fc-2D2E36 mt-32">
            Are you sure you want to delete this performance boost?
          </div>
          <div class="fs-14 fc-2D2E36 mt-24">
            This will permanently remove the performance boost for {{ deleteReviewDialog.employee ?
              deleteReviewDialog.employee.firstname || '' : '' }} {{ deleteReviewDialog.employee ?
              deleteReviewDialog.employee.lastname || '' : '' }} from {{ deleteReviewDialog.month || '' }}.
          </div>

          <!-- Preview of the performance review -->
          <div class="review-preview mt-24 p-16" style="background: #FCEFF4; border-radius: 8px; text-align: left;">
            <div class="fs-16 fw-700 mb-8">Boost Preview</div>
            <div v-if="deleteReviewDialog.reviewItem">
              <div class="fs-14 mb-8"><strong>Month:</strong> {{ deleteReviewDialog.reviewItem.month }}</div>
              <div class="fs-14 mb-8"><strong>Goals Feedback<br></strong> {{ deleteReviewDialog.reviewItem.text }}</div>
              <div class="fs-14"><strong>Culture Feedback<br></strong> {{ deleteReviewDialog.reviewItem.text1 }}</div>
            </div>
          </div>

          <div class="fs-14 fw-600 fc-2D2E36 mt-16" style="color: #F44336;">
            This action cannot be undone.
          </div>
          <div class="pl-20 pr-20 mt-24 mb-24">
            <div class="flex-center" style="justify-content: center;">
              <el-button class="btn secondary mr-12"
                style="width: 120px; height: 40px; border: 1px solid #D8D8D8; color: #4D4D4D; background: #FFFFFF;"
                @click="deleteReviewDialog.visible = false">
                CANCEL
              </el-button>
              <el-button class="btn"
                style="width: 120px; height: 40px; background: #F44336; color: #FFFFFF; border: none;"
                @click="deleteReview">
                DELETE
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
Chart.defaults.font.family = "Lato";
import ChartDataLabels from "chartjs-plugin-datalabels";
import addMonths from 'date-fns/add_months';
import format from 'date-fns/format'
import _ from 'lodash'
export default {
  name: "performance",
  components: {
    loadingEven: require("../even/loading").default,
  },
  data() {
    return {
      selectTeam: "All Teams",
      realDataMainTreeTable: [],
      loadingMainData: false,
      list_select: 'Highest Completion Rate',
      inputSearch: '',
      expandkay: [],
      status_show_preset_forms: true,

      list: ['Highest Completion Rate',

        'Lowest Completion Rate',

        'Highest Goal Progress',

        'Lowest Gaol Progress',

        'Highest Culture Add',

        'Lowest Culture Add',

        'Highest Both',

        'Lowest Both',],
      month: format(addMonths(new Date(), -6), 'MMM'),
      showModal_presets: false,
      createPreset_status: false,
      status_show_preset_form: true,
      presetForm: {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        user: [],

      },
      presetForm_old: {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        user: [],
      },
      index_focus: '',
      popup_preset: {
        show: false,
        title: '',
        content: '',
        button_left: '',
        button_right: '',
      },
      addMemberTeam: false,
      addMemberTeamForm: {
        title_left: '',
        type: '',
        title: '',
        description: '',
        team: [],
        user: [],
        selected: [],
        placeholder: ''
      },
      searchmemberandteamandMember: '',
      selected_team: [],
      selected_user: [],
      inputSearch_preset: '',
      confirm_add_dialog: false,
      text_confirm: '',
      duplicateTeamandMamger: '',
      status_duplicate: false,
      title_preset: '',
      presetForm_verify: {
        name: false,
        goals: false,
        culture: false,
        next_review: false,
      },
      status_edit_preset: false,
      deleteReviewDialog: {
        visible: false,
        employee: null,
        reviewItem: null,
        month: ''
      },
      activeFilter: {
        culture: null,
        goal: null,
        status: null
      },
      expandedRowKeys: [],
      childBorder: true,  // Add this line to define the childBorder property
      statusFilters: {
        completed: true,
        pending: true,
        overdue: true
      }
    };
  },
  created() {
    this.$store.dispatch("performance/getTeam", this.user);
    this.$store.dispatch("performance/getOrganization", this.user);
    //this.$store.dispatch("performance/getSendReviewGem", this.user);
    //this.$store.dispatch('performance/getmemberInteam')




  },
  computed: {

    user() {
      return this.$store.getters["authen/user"];
    },
    teamAndcohort() {
      return this.$store.getters["performance/team"];
    },
    datachart() {
      return this.$store.getters["performance/datachart"];
    },
    reviewActivity() {
      return this.$store.getters["performance/reviewActivity"];
    },
    avg() {
      return this.$store.getters["performance/avg"];
    },
    ChartGoalandCuture() {
      return this.$store.getters["performance/ChartGoalandCuture"];
    },
    tableData() {
      return this.$store.getters["performance/tableData"];
    },
    loading() {
      return this.$store.getters["performance/loading"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    presetlist() {
      return this.$store.getters["performance/presetlist"];
    },
    presetlistAll() {
      return this.$store.getters["performance/presetlistAll"];
    },
    memberInteam() {
      return this.$store.getters["performance/memberInteam"];
    },
    member() {
      return this.$store.getters["performance/member"];
    },
    loading_preset() {
      return this.$store.getters["performance/loading_preset"];
    },
    isFiltered() {
      return this.activeFilter.culture !== null && this.activeFilter.goal !== null;
    },
    expandedRows() {
      return this.expandedRowKeys;
    },
    statusCounts() {
      // Calculate counts for each status type across all data
      const counts = {
        completed: 0,
        pending: 0,
        overdue: 0
      };
      
      // For filtered counts when a filter is active
      const filteredCounts = {
        completed: 0,
        pending: 0, 
        overdue: 0
      };
      
      // If data is still loading, return empty counts
      if (this.loading || !this.tableData) {
        return { total: counts, filtered: filteredCounts };
      }
      
      // Process all data items (parents and children) for total counts
      this.tableData.forEach(item => {
        // Count the parent item's status if it has one
        if (item.reviews_status === 'Completed') counts.completed++;
        else if (item.reviews_status === 'Pending') counts.pending++;
        else if (item.reviews_status === 'Overdue') counts.overdue++;
        
        // Process all family members (children) if they exist
        if (item.family && Array.isArray(item.family)) {
          item.family.forEach(familyMember => {
            if (familyMember.reviews_status === 'Completed') counts.completed++;
            else if (familyMember.reviews_status === 'Pending') counts.pending++;
            else if (familyMember.reviews_status === 'Overdue') counts.overdue++;
          });
        }
      });
      
      // Only calculate filtered counts if a filter is active
      if (this.isFiltered) {
        // Directly calculate filtered counts instead of using filteredTableData
        // to avoid circular dependency
        const cultureText = this.getCultureText(this.activeFilter.culture);
        const goalText = this.getGoalText(this.activeFilter.goal);
        
        this.tableData.forEach(item => {
          // Check if this parent matches the filter criteria
          const parentMatches = this.checkItemMatch(
            item,
            this.activeFilter.culture,
            this.activeFilter.goal,
            cultureText,
            goalText,
            this.activeFilter.status
          );
          
          // Only count if the parent matches and has the relevant status
          if (parentMatches) {
            if (item.reviews_status === 'Completed') filteredCounts.completed++;
            else if (item.reviews_status === 'Pending') filteredCounts.pending++;
            else if (item.reviews_status === 'Overdue') filteredCounts.overdue++;
          }
          
          // Process family members
          if (item.family && Array.isArray(item.family)) {
            item.family.forEach(familyMember => {
              // Check if this family member matches the filter criteria
              const memberMatches = this.checkItemMatch(
                familyMember,
                this.activeFilter.culture,
                this.activeFilter.goal,
                cultureText,
                goalText,
                this.activeFilter.status
              );
              
              // Only count if the family member matches and has the relevant status
              if (memberMatches) {
                if (familyMember.reviews_status === 'Completed') filteredCounts.completed++;
                else if (familyMember.reviews_status === 'Pending') filteredCounts.pending++;
                else if (familyMember.reviews_status === 'Overdue') filteredCounts.overdue++;
              }
            });
          }
        });
      } else {
        // If no filter is active, filtered counts are the same as total counts
        filteredCounts.completed = counts.completed;
        filteredCounts.pending = counts.pending;
        filteredCounts.overdue = counts.overdue;
      }
      
      return { total: counts, filtered: filteredCounts };
    },
    filteredTableData() {
      const data = [...this.tableData];
      if (!this.isFiltered) {
        return data;
      }

      console.log('Filtering with:', this.activeFilter);
      console.log('Status filters:', this.statusFilters); // Add this to make it dependent on statusFilters

      const cultureText = this.getCultureText(this.activeFilter.culture);
      const goalText = this.getGoalText(this.activeFilter.goal);

      if (this.activeFilter.status) {
        console.log(`Looking for Status: "${this.activeFilter.status}"`);
      } else {
        console.log(`Looking for Culture: "${cultureText}" and Goal: "${goalText}"`);
      }

      // First, identify parent rows that have at least one matching child
      return this.tableData.map(item => {
        // Create a clone of the item to avoid modifying the original data
        const clonedItem = { ...item };

        // Check if this parent itself matches
        const parentMatches = this.checkItemMatch(
          item,
          this.activeFilter.culture,
          this.activeFilter.goal,
          cultureText,
          goalText,
          this.activeFilter.status
        );

        // If this item has family members, filter them
        if (clonedItem.family && clonedItem.family.length > 0) {
          // Only keep family members that match the filter criteria
          const filteredFamily = clonedItem.family.filter(familyMember =>
            this.checkItemMatch(
              familyMember,
              this.activeFilter.culture,
              this.activeFilter.goal,
              cultureText,
              goalText,
              this.activeFilter.status
            )
          );

          // Update the family array with only matching members
          clonedItem.family = filteredFamily;

          // If parent matches or has at least one matching family member, include it
          return (parentMatches || filteredFamily.length > 0) ? clonedItem : null;
        }

        // If no family members but parent matches, include it
        return parentMatches ? clonedItem : null;
      }).filter(item => item !== null); // Remove any null items (non-matching parents)
    },
  },
  watch: {
    ChartGoalandCuture() { },
    datachart() {
      if (this.myChart1) this.myChart1.destroy()
      this.createChart();
    },
    inputSearch() {
      setTimeout(() => {
        this.searchData(this.inputSearch)
      }, 500);
    },
    async searchmemberandteamandMember() {
      //console.log("searchmemberandteam",this.searchmemberandteamandMember)
      await this.$store.dispatch("performance/searchmemberandteamandMember", { value: this.searchmemberandteamandMember, type: this.addMemberTeamForm.type })
      if (this.addMemberTeamForm.type == 'team') {
        this.addMemberTeamForm.team = []
        for (const key in this.memberInteam) {
          const _team = _.find(this.selected_team, { name: this.memberInteam[key].name })
          if (_team) {
            this.addMemberTeamForm.team.push({ key: key, statusClick: true, ...this.memberInteam[key] })
          } else {
            this.addMemberTeamForm.team.push({ key: key, statusClick: false, ...this.memberInteam[key] })
          }

        }
      }
      else {
        this.addMemberTeamForm.user = []
        for (const key in this.member) {
          //console.log('this.member',this.member[key])
          const _member = _.find(this.selected_user, { email: this.member[key].email })
          if (_member) {
            this.addMemberTeamForm.user.push({ key: key, statusClick: true, ...this.member[key] })

          } else {
            this.addMemberTeamForm.user.push({ key: key, statusClick: false, ...this.member[key] })
          }

        }
      }
      //this.$store.dispatch("performance/searchData", this.searchmemberandteam)
    },
    inputSearch_preset: {
      handler(newVal) {
        //console.log('newVal',newVal)
        this.$store.dispatch("performance/searchData_preset", newVal)
        //this.searchmemberandteam()
      },
      deep: true
    },

    presetForm: {
      handler(newVal) {
        this.checkedChanges()

      },
      deep: true
    },
  },

  // mounted() {
  // this.createChart();

  // },
  methods: {
    format,  // Add this
    addMonths, // Add this
    async changMainPageData(key) {
      // console.log(key);
      this.$store.dispatch("performance/changeTeam", key);
    },
    getReviewsStatus(value) {
      const max = this.reviewActivity.total
      return ((value / max) * 100).toFixed();
    },
    getStatusColor(status) {
      if (status == "Completed") {
        return "rgba(102, 187, 106, 0.1)";
      } else if (status == "Pending") {
        return "rgba(204, 149, 10, 0.1)";
      } else if (status == "Overdue") {
        return "rgba(244, 67, 54, 0.1)";
      }
    },
    getStatusColortext(status) {
      if (status == "Completed") {
        return "rgb(102, 187, 106)";
      } else if (status == "Pending") {
        return "rgb(204, 149, 10)";
      } else if (status == "Overdue") {
        return "rgb(244, 67, 54)";
      }
    },
    getgoalsColor(goal) {
      if (goal == "Met" || goal == "Exceeded") {
        return "rgba(125, 90, 186, 0.1)";
      } else if (goal == "Did not Meet" || goal == "Partially") {
        return "rgba(126, 126, 126, 0.1)";
      }
    },
    getgoalsColortext(goal) {
      if (goal == "Met" || goal == "Exceeded") {
        return "rgb(125, 90, 186)";
      } else if (goal == "Did not Meet" || goal == "Partially") {
        return "rgb(126, 126, 126)";
      }
    },
    getcultureAddColor(culture) {
      if (culture == "Significantly" || culture == "Consistently") {
        return "rgba(86, 130, 163, 0.1)";
      } else if (culture == "Somewhat" || culture == "Rarely") {
        return "rgba(126, 126, 126, 0.1)";
      }
    },
    getcultureAddColortext(culture) {
      if (culture == "Significantly" || culture == "Consistently") {
        return "rgb(86, 130, 163)";
      } else if (culture == "Somewhat" || culture == "Rarely") {
        return "rgb(126, 126, 126)";
      }
    },
    calculateDimension(score, max_score) {

      if (score === 0) {
        return 8;
      } else {
        return Math.max((score / max_score) * 66, 16);
      }
    },
    searchData() {
      this.$store.dispatch("performance/searchData", this.inputSearch);
    },
    exportdata(data) {
      const text = 'Preparing and downloading your performance data...'
      this.$message({
        type: "warning",
        message: text,
        duration: "9999000",
      });
      this.$store.dispatch('performance/download', data).then((res) => {
        this.$message.closeAll();
        this.$message({
          type: "success",
          message: "Your performance data has been downloaded successfully",
          duration: 3000,
        });
      }).catch((err) => {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "There was an error downloading your performance data",
          duration: 3000,
        });
      })
    },
    selectOption(item) {
      // console.log('cheangeItem', item)
      this.list_select = item
      this.$store.dispatch("performance/sortbydata", item);
    },
    createChart() {
      var PerformanceChart = this.$refs.PerformanceChart;
      if (PerformanceChart) {
        //console.log('dated', this.datachart)
        var ctx = PerformanceChart.getContext("2d");
        var gradientFill = ctx.createLinearGradient(0, 0, 0, 255);
        gradientFill.addColorStop(1, "rgba(255,111,145, 0)");
        gradientFill.addColorStop(0, "rgba(255,111,145,0.4)");
        const label = []
        for (let i = 0; i < 6; i++) {
          label.push(format(addMonths(new Date(), -6 + i), 'MMM'))
        } label.push('Today')
        this.myChart1 = new Chart(PerformanceChart, {
          type: "line",
          data: {
            labels: label,//['Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Today'],
            datasets: [
              {
                label: "Culture Add",
                data: this.datachart.cultuerAdd,//[10, 30, 20, 50, 45, 60, 50],
                fill: false,
                borderColor: '#5682A3',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 0
              },
              {
                label: "Goals Progress",
                data: this.datachart.GoalsProgress,//[ 30, 19, 30, 40, 50, 75, 80],
                fill: false,
                borderColor: '#7D5ABA',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 0,

              },
              {
                label: "Both",
                data: this.datachart.Both,//[18, 30, 19, 40, 30, 62, 40],
                fill: true,
                borderColor: '#FF6F91',
                borderWidth: 2,
                backgroundColor: gradientFill,
                fill: true,

                pointStyle: function (context) {
                  let index = context.dataIndex;
                  if (index == 6) {
                    return 'circle';
                  } else {
                    return 'line';
                  }

                },
                pointRadius: function (context) {
                  let index = context.dataIndex;
                  if (index == 6) {
                    return 3;
                  } else {
                    return 1;
                  }
                },
              },

            ],
          },
          options: {
            interaction: {
              intersect: false,
              mode: 'nearest'
            },
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    let label = context.dataset.label || '';
                    if (label) {
                      label += ': ';
                    }
                    if (context.parsed.y !== null) {
                      label += Math.ceil(context.parsed.y) + '%';
                    }
                    return label;
                  }
                }
              }
            },
            scales: {
              x: {
                title: {
                  display: false,
                  text: '',
                  font: {
                    family: 'Lato',
                    size: 11,
                    style: 'bold',
                    weight: 'bold',
                    lineHeight: 1.2,
                  },
                  color: 'rgba(0,0,0,0.70)'
                },
                grid: {
                  display: false
                },
                ticks: {
                  display: false
                },
                display: false // added this line to hide the x-axis
              },
              y: {
                grid: {
                  display: true
                },
                beginAtZero: true,
                display: true, // changed this to false to hide the y-axis
                showLine: false,
                min: 0,
                max: 100,
                ticks: {
                  stepSize: 50,
                  font: {
                    family: 'Lato',
                    size: 10,
                    style: 'bold',
                    weight: 'bold'
                  },
                  callback: function(value) {
                    return Math.ceil(value) + '%';
                  }
                }
              }
            },
            elements: {
              line: {
                tension: 0.4,
              },
            },
            responsive: true,
          }
        });
      }
    },
    createPreset() {

      this.clearfocusPreset()
      this.clearData()
      this.status_edit_preset = false
      this.title_preset = 'Create Preset'
      this.status_show_preset_forms = false
      this.createPreset_status = true

    },
    OnClickModalPresets() {
      this.$store.dispatch('performance/getmemberInteam')
      this.showModal_presets = true

    },
    ClickEditPresets(item) {
      const _presetlist = _.cloneDeep(this.presetlist[item])
      this.title_preset = 'Edit Preset'
      if (this.index_focus !== '') {
        this.presetlist[this.index_focus].focus_preset = false
      }
      this.status_edit_preset = true
      this.presetlist[item].focus_preset = true
      this.status_show_preset_forms = false
      this.presetForm.preset_id = _presetlist.id
      this.presetForm.name = _presetlist.name || ''
      this.presetForm.goals = _presetlist.goals || ''
      this.presetForm.culture = _presetlist.culture || ''
      this.presetForm.next_review = _presetlist.next_review || ''
      this.presetForm.team = _presetlist.team || []
      this.presetForm.users = _presetlist.data_users || []
      this.presetForm.team = _presetlist.data_team || []
      this.selected_team = _.cloneDeep(this.presetForm.team)
      this.selected_user = _.cloneDeep(this.presetForm.users)
      this.presetForm_old = _.cloneDeep(this.presetForm)
      this.index_focus = item

    },
    closeModalPresets() {
      this.showModal_presets = false
      this.status_show_preset_forms = true
      this.clearData()
    },
    clearfocusPreset() {
      for (const key in this.presetlist) {
        this.presetlist[key].focus_preset = false
      }
      //console.log('this.presetlist==',this.presetlist)
    },
    checkedChanges() {

      const check_preset = _.isEqual(this.presetForm, this.presetForm_old)
      if (!check_preset) {
        if (this.createPreset_status) {
          this.popup_preset = {
            show: true,
            title: 'Create new preset',
            content: '',
            status: 'create',
            button_left: 'Clear',
            button_right: 'Save Preset',
          }

        } else {
          this.popup_preset = {
            show: true,
            title: 'Update your preset',
            content: '',
            status: 'update',
            button_left: 'Delete',
            button_right: 'Save Changes',
          }

        }

      } else {
        if (this.status_edit_preset) {
          this.popup_preset = {
            show: true,
            title: 'Update your preset',
            content: '',
            status: 'update',
            button_left: 'Delete',
            button_right: '',
          }
        } else {
          // console.log('no changes')
          this.popup_preset = {
            show: false,
            title: '',
            content: '',
            button_left: '',
            button_right: '',
          }

        }

      }
    },
    clearData() {
      this.createPreset_status = false
      this.presetForm = {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        status: true,
        user: [],
      }
      this.presetForm_old = {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        status: true,
        user: [],
      }
      this.presetForm_verify = {
        name: false,
        goals: false,
        culture: false,
        next_review: false,
      }

    },
    async deleteUser(email) {
      this.presetForm.users = _.filter(this.presetForm.users, (obj) => { return obj.email !== email })
      this.selected_user = _.filter(this.selected_user, (obj) => { return obj.email !== email })
      for (const key in this.addMemberTeamForm.user) {
        if (email == this.addMemberTeamForm.user[key].email) {
          this.addMemberTeamForm.user[key].statusClick = false
        }
      }
      this.checkedChanges()
      this.$forceUpdate()

    },
    deleteTeam(team) {
      //console.log('deleteTeam', team)
      this.presetForm.team = _.filter(this.presetForm.team, (obj) => { return obj.id !== team })
      this.selected_team = _.filter(this.selected_team, (obj) => { return obj.id !== team })

      for (const key in this.addMemberTeamForm.team) {
        if (team == this.addMemberTeamForm.team[key].id) {
          this.addMemberTeamForm.team[key].statusClick = false
        }
      }
      this.checkedChanges()
      this.$forceUpdate()
    },
    gettextAssigned(team, member) {
      if (team > 0 && member == 0) {
        if (team == 1) { return 'Assigned to 1 team' }
        return `Assigned to ${team} teams`
      } else if (team == 0 && member > 0) {
        if (member == 1) { return 'Assigned to 1 member' }
        return `Assigned to ${member} members`
      } else {
        if (team == 1 && member == 1) { return 'Assigned to 1 team and 1 member' }
        return `Assigned to ${team} teams and ${member} members`
      }
    },
    verifyPreset() {
      if (this.presetForm.name == '') {
        this.presetForm_verify.name = true
      } else {
        this.presetForm_verify.name = false
      }
      if (this.presetForm.goals == '') {
        this.presetForm_verify.goals = true
      } else {
        this.presetForm_verify.goals = false
      }
      if (this.presetForm.culture == '') {
        this.presetForm_verify.culture = true
      } else {
        this.presetForm_verify.culture = false
      }
      if (this.presetForm.next_review == '') {
        this.presetForm_verify.next_review = true
      } else {
        this.presetForm_verify.next_review = false
      }

    },
    async savePreset() {
      //console.log('savePreset')
      this.verifyPreset()
      if (this.presetForm_verify.name == true || this.presetForm_verify.goals == true || this.presetForm_verify.culture == true || this.presetForm_verify.next_review == true) {
        return
      } else {
        this.$store.dispatch('performance/updateAndCreatePreset', { preset: this.presetForm, duplicate: this.duplicateTeamandMamger })
        this.status_duplicate = false
        this.clearData()

      }

    },
    async deletePreset() {
      //console.log('deletePreset')
      this.$store.dispatch('performance/deletePreset', { preset_id: this.presetForm.preset_id })
      this.clearData()
    },
    openAddMemberTeam(type) {
      this.addMemberTeamForm.team = []
      this.addMemberTeamForm.user = []
      this.addMemberTeam = true
      if (type == 'member') {
        this.addMemberTeamForm.type = 'member'
        this.addMemberTeamForm.title_left = 'members selected'
        this.addMemberTeamForm.title = `Add members to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.placeholder = 'Search member name'

        for (const key in this.member) {

          const _user = _.find(this.selected_user, function (item) { return item.email == key })
          if (_user) {
            this.addMemberTeamForm.user.push({ key: key, statusClick: true, ...this.member[key] })
          } else {
            this.addMemberTeamForm.user.push({ key: key, statusClick: false, ...this.member[key] })
          }

        }
        //console.log('addMemberTeamForm',this.addMemberTeamForm)

      } else {
        // console.log('add team',this.memberInteamAll)
        this.addMemberTeamForm.type = 'team'
        this.addMemberTeamForm.title = `Add teams to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left = 'teams selected'
        this.addMemberTeamForm.placeholder = 'Search team name'
        //console.log("key",this.selected_team)
        for (const key in this.memberInteam) {

          const _team = _.find(this.selected_team, function (item) { return item.id == key })
          if (_team) {
            this.addMemberTeamForm.team.push({ key: key, statusClick: true, ...this.memberInteam[key] })
          } else {
            this.addMemberTeamForm.team.push({ key: key, statusClick: false, ...this.memberInteam[key] })
          }

        }


      }

    },
    selectedTeamAndMember(id, type) {

      if (type == 'team') {
        this.addMemberTeamForm.team[id].statusClick = !this.addMemberTeamForm.team[id].statusClick
        const _find_team = this.selected_team.filter((item) => { return item.id === this.addMemberTeamForm.team[id].id })
        if (_find_team.length == 0) {
          this.selected_team.push({ membersteams: this.addMemberTeamForm.team[id].users ? this.addMemberTeamForm.team[id].users.length : 0, name: this.addMemberTeamForm.team[id].name, id: this.addMemberTeamForm.team[id].id, newteam: true })
        } else {
          this.selected_team = this.selected_team.filter((item) => { return item.id !== this.addMemberTeamForm.team[id].id })
        }
        // this.selected_team=this.addMemberTeamForm.team[id]
      } else {

        this.addMemberTeamForm.user[id].statusClick = !this.addMemberTeamForm.user[id].statusClick
        const _find_user = this.selected_user.filter((item) => { return item.email === this.addMemberTeamForm.user[id].email })
        if (_find_user.length == 0) {
          this.selected_user.push({ email: this.addMemberTeamForm.user[id].email, firstname: this.addMemberTeamForm.user[id].firstname, lastname: this.addMemberTeamForm.user[id].lastname, team_name: this.addMemberTeamForm.user[id].team_name, profilepic_crop: this.addMemberTeamForm.user[id] && this.addMemberTeamForm.user[id].profilepic_crop ? this.addMemberTeamForm.user[id].profilepic_crop : '', newuser: true })
        } else {
          this.selected_user = this.selected_user.filter((item) => { return item.email !== this.addMemberTeamForm.user[id].email })
        }
      }


      this.$forceUpdate()
    },
    cancelselectedTeamandMember() {
      //console.log('cancelselectedTeamandMember',this.addMemberTeamForm.type)
      if (this.addMemberTeamForm.type == 'team') {
        this.selected_team = this.presetForm && this.presetForm.team ? this.presetForm.team : []
      } else {
        this.selected_user = this.presetForm && this.presetForm.users ? this.presetForm.users : []
      }
      this.searchmemberandteamandMember = ''
      this.addMemberTeam = false

    },
    submitselectedTeamandMember() {
      this.checkTeamAndMember()
      this.checkedChanges()
    },
    checkTeamAndMember() {
      this.text_confirm = []

      //console.log('checkTeamAndMember',this.presetlistAll)
      const _presetlistAll = _.cloneDeep(this.presetlistAll)

      let _presetlistChange = _.cloneDeep(this.presetlistAll)
      if (this.status_duplicate == true) {
        _presetlistChange = this.duplicateTeamandMamger
      }

      if (this.addMemberTeamForm.type == 'team') {
        for (const key in _presetlistAll) {
          //console.log('key',key)
          const teams = []
          _presetlistChange[key].teams = []
          if (_presetlistAll[key].teams) {
            for (const team of _presetlistAll[key].teams) {
              //console.log('team',team)
              const _find_team = this.selected_team.filter((item) => { return item.id === team })
              if (_find_team.length > 0) {
                if (_find_team[0].newteam) {
                  const text = `• Team "${_find_team[0].name}" is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key].status_duplicate_team = true
                  this.status_duplicate = true
                }
              } else {
                teams.push(team)
              }

            }
            if (teams.length > 0) {
              _presetlistChange[key].teams = teams
            }

          }

        }

        this.duplicateTeamandMamger = _presetlistChange
        this.confirm_add_dialog = true
      } else {
        for (const key in _presetlistAll) {

          const users = []
          _presetlistChange[key].users = []
          if (_presetlistAll[key].users) {
            for (const user of _presetlistAll[key].users) {
              const _find_user = this.selected_user.filter((item) => { return item.email === user })

              if (_find_user.length > 0) {
                if (_find_user[0].newuser) {
                  const text = `• Member "${_find_user[0].firstname} ${_find_user[0].lastname}" is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key].status_duplicate_user = true
                  this.status_duplicate = true
                }
              } else {
                _presetlistChange[key].users.push(user)

              }

            }
          }
        }

        this.duplicateTeamandMamger = _presetlistChange
        this.confirm_add_dialog = true
      }
      if (this.text_confirm == '') {
        this.confirm_Add()
      }

    },
    handleClose() {
      this.confirm_add_dialog = false
    },
    confirm_Add() {

      if (this.addMemberTeamForm.type == 'team') {
        this.presetForm.team = this.selected_team
      } else {
        this.presetForm.users = this.selected_user
      }
      this.addMemberTeam = false
      this.searchmemberandteamandMember = ''
      this.confirm_add_dialog = false
      this.checkedChanges()
    },
    confirmDeleteReview(employee, reviewItem) {
      
      this.deleteReviewDialog.visible = true;
      this.deleteReviewDialog.reviewItem = reviewItem;
      this.deleteReviewDialog.employee = employee;
      this.deleteReviewDialog.month = reviewItem.month;
    },
    deleteReview() {
      // Here you would implement the actual deletion logic
      // For example:
      this.$store.dispatch('performance/deleteReview', {
        employeeId: this.deleteReviewDialog.employee.key,
        employeegem: this.deleteReviewDialog.employee.gem,
        reviewId: this.deleteReviewDialog.reviewItem.review_id,
        team: this.selectTeam
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Performance review deleted successfully'
        });
        // Refresh data if needed
        //this.isFiltered = false;
        //this.filteredTableData=[]
        //this.$store.dispatch("performance/getSendReviewGem", this.selectTeam);
        //this.changMainPageData(this.selectTeam);
      }).catch(error => {
        this.$message({
          type: 'error',
          message: 'Failed to delete performance review: ' + error.message
        });
      });

      // Close the dialog
      this.deleteReviewDialog.visible = false;
    },
    filterGridData(culture, goal, status = null) {
      // If clicking the same cell, clear the filter
      if (culture !== null && goal !== null && this.activeFilter.culture === culture && this.activeFilter.goal === goal) {
        this.clearFilter();
        return;
      }

      // Update the filter
      if (culture !== null && goal !== null) {
        this.activeFilter.culture = culture;
        this.activeFilter.goal = goal;
        this.activeFilter.status = null; // Clear status when filtering by culture/goal

        // Initialize status filters to true (show all)
        this.statusFilters.completed = true;
        this.statusFilters.pending = true;
        this.statusFilters.overdue = true;
      }

      // First, ensure we clear any existing expansions
      this.expandedRowKeys = [];

      // Use both nextTick and a short timeout to ensure expansion happens
      // after the table is fully re-rendered with filtered data
      this.$nextTick(() => {
        setTimeout(() => {
          // Expand all parent rows that have family members
          this.expandedRowKeys = this.filteredTableData
            .filter(item => item.family && item.family.length > 0)
            .map(item => item.email);
        }, 100); // Small delay to ensure the table has completely updated
      });
    },

    clearFilter() {
      this.activeFilter.culture = null;
      this.activeFilter.goal = null;
      this.activeFilter.status = null;

      // Reset status filters
      this.statusFilters.completed = false;
      this.statusFilters.pending = false;
      this.statusFilters.overdue = false;

      this.expandedRowKeys = []; // Collapse all rows when clearing filter
    },

    getFilterLabel() {
      if (!this.isFiltered) {
        return "";
      }

      const cultureMap = {
        4: "Significantly",
        3: "Consistently",
        2: "Somewhat",
        1: "Rarely"
      };

      const goalMap = {
        4: "Exceeded",
        3: "Met",
        2: "Partially",
        1: "Did not Meet"
      };

      return `${cultureMap[this.activeFilter.culture]} + ${goalMap[this.activeFilter.goal]}`;
    },
    getCultureText(value) {
      const map = {
        4: "Significantly",
        3: "Consistently",
        2: "Somewhat",
        1: "Rarely"
      };
      return map[value] || '';
    },

    getGoalText(value) {
      const map = {
        4: "Exceeded",
        3: "Met",
        2: "Partially",
        1: "Did not Meet"
      };
      return map[value] || '';
    },
    getCellCount(culture, goal) {
      if (!culture || !goal || !this.ChartGoalandCuture[culture] || !this.ChartGoalandCuture[culture][goal]) {
        return 0;
      }
      return this.ChartGoalandCuture[culture][goal];
    },
    checkItemMatch(item, cultureValue, goalValue, cultureText, goalText, status = null) {
      // If no filters are active, return true
      if (cultureValue === null && goalValue === null && status === null) {
        return true;
      }

      // Check status filtering based on statusFilters
      if (this.isFiltered && item.reviews_status) {
        // If any status is unchecked (false), but this item has that status, exclude it
        if (item.reviews_status === 'Completed' && this.statusFilters.completed === false) {
          return false;
        }
        if (item.reviews_status === 'Pending' && this.statusFilters.pending === false) {
          return false;
        }
        if (item.reviews_status === 'Overdue' && this.statusFilters.overdue === false) {
          return false;
        }
      }

      // If we're filtering by culture/goal (not just status)
      if (cultureValue !== null && goalValue !== null) {
        // Direct numeric value match
        const numericMatch =
          (item.culture === cultureValue || item.cultureValue === cultureValue) &&
          (item.goal === goalValue || item.goalValue === goalValue);

        if (numericMatch) {
          return true;
        }

        // Check for exact text matches
        if (item.cultureText && item.goalText) {
          const itemCultureText = item.cultureText.trim().toLowerCase();
          const itemGoalText = item.goalText.trim().toLowerCase();
          const targetCultureText = cultureText.trim().toLowerCase();
          const targetGoalText = goalText.trim().toLowerCase();

          // Check for exact matches
          const exactMatch =
            itemCultureText === targetCultureText &&
            itemGoalText === targetGoalText;

          if (exactMatch) {
            return true;
          }

          // Check if one text includes the other (more relaxed matching)
          const containsMatch =
            (itemCultureText.includes(targetCultureText) || targetCultureText.includes(itemCultureText)) &&
            (itemGoalText.includes(targetGoalText) || targetGoalText.includes(itemGoalText));

          if (containsMatch) {
            return true;
          }

          // Special case for "Partially" and "Partially Met"
          if (itemGoalText.includes("partially") && targetGoalText.includes("partially")) {
            return itemCultureText === targetCultureText;
          }
        }

        return false;
      }

      return true;
    },
    updateStatusFilters() {
      // Force a re-render by setting a temporary value
      const originalCulture = this.activeFilter.culture;
      const originalGoal = this.activeFilter.goal;

      // Reset expansions
      this.expandedRowKeys = [];

      // Use nextTick to ensure the table updates before expanding rows
      this.$nextTick(() => {
        setTimeout(() => {
          // Expand all parent rows that have family members after filtering
          this.expandedRowKeys = this.filteredTableData
            .filter(item => item.family && item.family.length > 0)
            .map(item => item.email);
        }, 100);
      });
    }
  },
};
</script>

<style scoped lang="scss">
.performance-container {
  background-color: #FBF9FC;
  padding: 24px 24px 12px 24px;
  border-radius: 24px;

}

.legend-box {
  width: 8px;
  height: 8px;
}

.box-complete {
  background-color: #66BB6A;
  border-radius: 2px;
}

.progress-bar {
  height: 4px;
}

.box-pending {
  background-color: #FBC02D;
  border-radius: 2px;
}

.box-overdue {
  background-color: #F44336;
  border-radius: 2px;
}

.box-performace {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  width: 77px;
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.box-performace-pink {
  background-color: #fff0f4;
  border-radius: 6px;
  width: 77px;
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.timeline {
  display: flex;
  justify-content: space-between;
  height: 14px;
  margin-top: -16px;
}

.tick {
  width: 14.28%;
  border-left: 1px solid rgba(0, 0, 0, 0.20);
}

.labels {
  display: flex;
  justify-content: space-between;
}

.labels .start {}

.labels .end {}

.rotate {
  width: 15px;
  height: 77px;
  writing-mode: tb-rl;
  transform: rotate(-180deg);

  position: relative;
}

.rotate-goal {
  width: 35px;
  height: 335px;
  writing-mode: tb-rl;
  transform: rotate(-180deg);

  position: relative;
}

.divCurcleStatus {
  width: 77px;
  height: 77px;
  text-align: center;
  border-radius: 50%;
}

.menuOptionPowerup {
  width: 240px;
  border-radius: 4px;
  height: 40px;
  // border: solid 1px #e6e6e6;
  background-color: #f4f4f4;
}

.menu-list-item {
  color: #4a4a4a;
}

.el-menu--horizontal .el-menu .el-menu-item:hover .menu-list-item {
  color: white;
  font-weight: 600;
}

.txtOptionShowing {
  color: #000000;
  font-size: 14px;
  margin-left: 16px;
}

#tabPerformance .divTable {
  margin-left: -32px;
}

#tabPerformance .divTable .el-table__header-wrapper {
  border-bottom: 1px solid #E0E0E0;
  padding-bottom: 8px;
  margin: 24px 0 16px 24px;
}

#tabPerformance .divTable .cell:has(.el-table__expand-icon--expanded) {
  padding: 0;
}

#tabPerformance .el-table__expanded-cell .el-table__header-wrapper {
  border-bottom: 0px;
  margin: 6px 0 0px 0;
  padding-bottom: 0;
}

#tabPerformance .el-table__expanded-cell .el-table .el-table__cell {
  padding: 6px 0;
}

#tabPerformance .nestedTable {
  margin: 0 16px 12px 72px;
}

#tabPerformance .el-table__expanded-cell .el-table__header-wrapper {
  margin: 0;
}

.nested-table {
  background-color: transparent;

  // Remove default table borders
  &::before {
    display: none;
  }

  .el-table__row {
    background-color: transparent;
  }
}

/* Empty state styling */
.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  margin: 24px 0;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background-color: #f5f0ff;
  border-radius: 50%;
  margin-bottom: 16px;
  
  i {
    font-size: 32px;
    color: #6C30CC;
  }
}

.empty-state-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.empty-state-message {
  font-size: 14px;
  color: #666666;
  max-width: 400px;
  margin-bottom: 24px;
}

.empty-state-suggestions {
  background-color: #f9f7fd;
  border-left: 3px solid #6C30CC;
  padding: 12px 24px;
  border-radius: 4px;
  text-align: left;
  margin-bottom: 24px;
  
  p {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  ul {
    padding-left: 16px;
    
    li {
      font-size: 13px;
      color: #666666;
      margin-bottom: 4px;
    }
  }
}

.empty-state-action {
  background-color: #6C30CC;
  border-color: #6C30CC;
  
  &:hover {
    background-color: #5b28ab;
    border-color: #5b28ab;
  }
}
</style>

<style lang="scss">
#tabPerformance .el-menu--horizontal>.el-menu-item {
  // color: rgba(0, 0, 0, 0.62);
  font-size: 14px;
  font-weight: 400;
  height: 40px;
}

#tabPerformance .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}

#tabPerformance .el-menu--horizontal>.el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}

#menuSortPerformanceData>li>div {
  border-radius: 4px;
  width: 240px;
  height: 40px;
  line-height: 40px;
}

#menuSortPerformanceData>li {
  margin-top: 0px;
  width: 240px;
  height: 40px;
}

#menuSortPerformanceData>li>div>i {
  margin-right: 9%;
  float: right;
  margin-top: 6%;
}

.count {
  text-align: center;
  font-family: 'Roboto';
  font-weight: 600;
}

#tabPerformance .divTable .el-table .el-table__cell {
  padding: 6px 0;
}

#tabPerformance .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #f7f5fa;
}

#tabPerformance .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:first-child {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

#tabPerformance .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:last-child {
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}

.name-link {
  text-decoration: none;
  color: inherit;
}

.el-table__row:hover .name-link {
  text-decoration: underline;
}

.hover-icon {
  opacity: 0;
  margin-left: 4px;
}

.el-table__row:hover .hover-icon {
  opacity: 1;
}

.modal-1 {
  overflow-y: scroll;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 0px 40px 40px 0px;
  opacity: 1;
  height: 84vh;
  min-height: 847px;
  padding-left: 40px;

  max-height: 1200px;

}

.modal-2 {
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}

#tabPerformance .el-dialog>.el-dialog__header {
  padding: 0px;
}

#tabPerformance .el-dialog>.el-dialog__body {
  padding: 0px;
  //  height: 84vh;
  //  min-height: 847px;
  //  max-height: 1200px;
}

.custom-textarea-preset .el-textarea__inner {
  width: 376px !important;
  height: 92px !important;
  font-size: 14px;
  resize: none;
  word-wrap: break-word;
  word-break: keep-all;
  padding: 12px 16px;

  &:focus {
    border-color: #6C30CC;
  }
}

.preset-focus {
  background: #F8F8F8 0% 0% no-repeat padding-box;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 6px;
  border-radius: 12px 0 0 12px;
}

.preset-library {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 6px;
}

.preset-library .arrow-right {
  padding-right: 32px;
  transition: padding-right 0.2s ease;
}

.preset-focus .arrow-right {
  padding-right: 16px;
  transition: padding-right 0.2s ease;
}

.selection-cell {
  width: 300px;
  margin-right: 12px;
  margin-bottom: 12px;
  background: #F7F7F7 0% 0% no-repeat padding-box;
  border-radius: 3px;
  opacity: 1;
  height: 64px;
  border: 1px solid #F7F7F7;
  cursor: pointer;
  border-radius: 6px;
}

.selection-cell.border-blue {
  border: 1px solid #6C30CC;
  background: #f7f2ff;
}

.warning-popup-1 {
  position: -webkit-sticky;
  position: sticky;
  width: 100%;
  bottom: 10px;
  z-index: 999;

  .body {
    z-index: 999;
    margin: auto;
    height: 52px;
    border-radius: 4px;
    background-color: #6c30cc;
    padding: 0px 12px 0 24px;

    .delete-bottom,
    .undo-bottom,
    .save-bottom {
      height: 32px;
      border-radius: 3px;
      color: #fff;
      transition: 0.2s;
      font-size: 13px;
      font-weight: 700;
    }

    .delete-bottom {
      width: 140px;
      background-color: #F44336;
      border: 1px solid #F44336;

      &:hover {
        background-color: #f45449;
      }
    }

    .undo-bottom {
      width: 52px;
      border: 1px solid #fff;

      &:hover {
        background-color: #00000010;
      }
    }

    .save-bottom {
      margin-left: 8px;
      width: 104px;
      border: 1px solid #32c2d5;
      background-color: #32c2d5;

      &:hover {
        background-color: #24afc2;
      }
    }
  }
}

.border-blue {
  border: 1px solid #32c2d5;
}

.validate-worming-data {
  .el-input__inner {
    border-color: #ed0e0e !important;
  }

  .el-textarea__inner {
    border-color: #ed0e0e !important;
  }

  .validate-worming-data-text {
    color: #ed0e0e !important;
    font-size: 10px;
  }
}
</style>

<style scoped>
/* Add this to your existing styles */
.delete-review-btn {
  color: #F44336;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}

.delete-review-btn:hover {
  opacity: 0.8;
}

.filter-status {
  display: flex;
  align-items: center;
  padding: 4px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.filter-status:hover {
  background-color: #e8eaed;
  transform: translateY(-1px);
}

.status-filters {
  background-color: #ffffff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.status-filter-checkbox {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.status-filter-checkbox:hover {
  background-color: #f0ebf9;
}

.status-filter-checkbox .el-checkbox__label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.status-count {
  font-size: 12px;
  font-weight: 500;
  color: #606266;
  opacity: 0.9;
  margin-left: 2px;
}

.status-filter-checkbox:nth-child(1) .status-count {
  color: #66BB6A;  /* Completed status color */
}

.status-filter-checkbox:nth-child(2) .status-count {
  color: #FBC02D;  /* Pending status color */
}

.status-filter-checkbox:nth-child(3) .status-count {
  color: #F44336;  /* Overdue status color */
}

.status-filters {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: #6C30CC;
      border-color: #6C30CC;
    }
  }
  
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #6C30CC;
  }
}

.active-filter {
  border-radius: 6px;
  transform: translateY(-2px);
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  animation: pulseGlow 2.5s infinite ease-in-out;
}

@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 4px rgba(119, 7, 255, 0.2);
  }

  50% {
    box-shadow: 0 0 12px rgba(127, 7, 255, 0.5);
  }

  100% {
    box-shadow: 0 0 4px rgba(119, 7, 255, 0.2);
  }
}

.box-performace {
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.box-performace:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.debug-info {
  width: 100%;
  padding: 12px 20px;
  background-color: #f9f7fd;
  border-left: 3px solid #6C30CC;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.clear-filter-btn {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.clear-filter-btn:hover {
  background-color: #5b28ab;
  border-color: #5b28ab;
}
</style>
